// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"10":"2fae68a5","84":"3afd5ebb","563":"2084f025","668":"9ee6e09a","925":"53781478"}[chunkId] + ".js";
};